import { notify } from "@kyvg/vue3-notification";
import router from "@/router";
import http from "@/utils/axios.js";
import { apiPaths } from "@/dictionaries/api/paths";

export default {
  namespaced: true,
  state: {
    doctor: {
      account_type: "",
      code: "",
      first_name: "",
      last_name: "",
      main_medical_category_id: null,
      pwz: "",
      phone_number: "",
      email: "",
      password: "",
      password_confirm: "",
      accept_terms: false,
      accept_marketing: false,
      accept_data_processing: false,
      agree_contact: false,
      commission_option: null,
      country_code: "PL",
      country: "Poland",
      national_number: null,
      phone_is_valid: false,
      type: "",
    },
    errors: [],
    commissionOptions: ["d15p0", "d10p5", "d5p10", "d0p15", "other"],
  },
  getters: {
    getPatient: (state) => state.patient,
    getErrors: (state) => state.errors,
    getDoctor: (state) => state.doctor,
    getCommissionOptions: (state) => state.commissionOptions,
    getServices: (state) => state.doctor.services,
  },
  mutations: {
    setPatient(state, patient) {
      Object.assign(state.patient, patient);
    },
    setDoctor(state, patient) {
      Object.assign(state.doctor, patient);
    },
    resetDoctor(state) {
      state.doctor = {
        code: "",
        first_name: "",
        last_name: "",
        main_medical_category_id: null,
        pwz: "",
        phone_number: "",
        email: "",
        password: "",
        password_confirm: "",
        accept_terms: false,
        accept_marketing: false,
        accept_data_processing: false,
        agree_contact: false,
        commission_option: null,
        country_code: null,
        country: null,
        national_number: null,
        phone_is_valid: false,
      };
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    clearErrors(state) {
      state.errors = [];
    },
    clearDoctor(state) {
      Object.keys(state.doctor).forEach((key) => (state.doctor[key] = ""));
      state.doctor.main_medical_category_id = null;
      state.doctor.accept_terms = false;
      state.doctor.accept_data_processing = false;
      state.doctor.agree_contact = false;
      state.doctor.accept_marketing = false;
      state.doctor.commission_option = null;
    },
  },
  actions: {
    async loginDoctor({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await http.post(apiPaths.login.exact, state.doctor);
          localStorage.authtoken = data.token;
          sessionStorage.removeItem("cart");
          http.defaults.headers.Authorization = "Bearer " + data.token;
          commit("clearErrors");
          commit("clearDoctor");
          resolve(data);
        } catch ({ response }) {
          if (response && response.status === 403)
            await router.push({
              name: "Blocked",
            });
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          reject();
        }
      });
    },
    async registerDoctor({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await http.post(
            apiPaths.register.exact,
            state.doctor,
          );
          localStorage.authtoken = data.token;
          http.defaults.headers.Authorization = "Bearer " + data.token;
          commit("clearErrors");
          resolve(data);
        } catch ({ response }) {
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          reject();
        }
      });
    },
    async verifyDoctor({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await http.post(apiPaths.register.verify, {
            code: state.doctor.code,
          });
          commit("clearErrors");
          resolve(data);
        } catch ({ response }) {
          if (response && response.status === 422)
            commit("setErrors", response.data.errors);
          reject();
        }
      });
    },
    async resendCodeDoctor() {
      await http
        .post(apiPaths.register.sendVerificationToken)
        .then(() => {
          notify({
            type: "success",
            text: "messages.code.resend",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 404)
            notify({
              type: "danger",
              text: "messages.code.resend_error",
              duration: 5000,
            });
        });
    },
  },
};
